<template>
  <el-card class="section-card owner-card" shadow="never">
    <div class="section-head">
      <div>
        <p class="eyebrow">Owner Actions</p>
        <h2>Add employee</h2>
        <p class="subcopy">Create or promote an employee record directly from the owner dashboard.</p>
      </div>
    </div>

    <el-form label-position="top" class="form-grid" @submit.prevent>
      <el-form-item label="Employee name">
        <el-input v-model.trim="form.name" maxlength="120" placeholder="Enter full name" />
      </el-form-item>

      <el-form-item label="Employee email">
        <el-input v-model.trim="form.email" maxlength="180" placeholder="Enter email address" />
      </el-form-item>

      <div class="actions">
        <el-button type="primary" :loading="saving" @click="submit">
          Add employee
        </el-button>
      </div>
    </el-form>
  </el-card>
</template>

<script>
import { ElMessage } from 'element-plus'
import { addEmployeeByOwner } from '@/services/owner'

export default {
  name: 'OwnerAddEmployeePanel',
  props: {
    currentUser: {
      type: Object,
      default: null,
    },
    ownerProfile: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      saving: false,
      form: {
        name: '',
        email: '',
      },
    }
  },
  methods: {
    async submit() {
      if (this.saving) return

      this.saving = true
      try {
        await addEmployeeByOwner({
          name: this.form.name,
          email: this.form.email,
          ownerUser: this.currentUser,
          ownerProfile: this.ownerProfile,
        })

        this.form.name = ''
        this.form.email = ''
        ElMessage({ type: 'success', message: 'Employee record saved successfully.', showClose: true })
      } catch (error) {
        ElMessage({
          type: 'error',
          message: error?.message || 'Unable to add this employee right now.',
          showClose: true,
          duration: 5000,
        })
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
.owner-card {
  border-radius: 22px;
}

.section-head {
  margin-bottom: 18px;
}

.eyebrow {
  margin: 0 0 6px;
  color: #0b6cff;
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

h2 {
  margin: 0 0 6px;
  color: #03241f;
  font-size: 1.5rem;
  font-weight: 850;
}

.subcopy {
  margin: 0;
  color: #4f6d67;
}

.form-grid {
  display: grid;
  gap: 8px;
  max-width: 680px;
}

.actions {
  margin-top: 6px;
}
</style>
